export default __webpack_public_path__ + "static/media/p22.98c79997.jpg";